<template>
    <div>
        <BTable small striped bordered :items="reduction?.positions || []" :fields="fields" responsive>
            <template #cell(diff_cost)="{ item }">
                <span><b>{{ cost(item) }}</b></span>
            </template>
            
            <template #cell(winner)="{ item }">
                <span>
                    <position_user text-empty="Ставок немає" :userId="winner(item)"></position_user>
                </span>
            </template>
            
            <template #cell(code)="{ item, toggleDetails }">
                <div class="icon-stack fs-xxl mr-2 cursor-pointer" @click="loadPreview(item.id, toggleDetails)">
                    <i class="base base-15 icon-stack-3x opacity-100 color-primary-900"></i>
                    <i class="fal fa-indent icon-stack-1x opacity-100 color-white"></i>
                </div>
            </template>
            
            <template #row-details="{ item }">
                <position_item :key="'bid_' + item.id" :item="item.id"></position_item>
            </template>
        </BTable>
    </div>
</template>


<script>
import { mapGetters } from 'vuex';
import {
    BTooltip,
    BTable
} from 'bootstrap-vue-next';
import Position_user from "./position/position_user.vue";
import Position_item from "./position/position_item.vue";


export default {
    name: "bind_reduction_positions",
    
    components : {
        Position_item,
        Position_user,
        BTable
    },
    
    data() {
        return {
            fields: [
                { key: 'code', label: 'Ставки', class: 'align-middle' },
                { key: 'title', label: 'Позиція', class: 'align-middle' },
                { key: 'catalog_number', label: 'Кат. номер', class: 'align-middle' },
                { key: 'unit', label: 'Од.', class: 'align-middle' },
                { key: 'quantity', label: 'К-сть', class: 'align-middle text-right' },
                { key: 'max_price', label: 'Ціна стартова', class: 'align-middle text-right' },
                { key: 'cur_cost', label: 'Ціна поточна', class: 'align-middle text-right' },
                { key: 'full_cost', label: 'Сума поточна', class: 'align-middle text-right' },
                { key: 'diff_cost', label: 'Зниження вартості', class: 'align-middle text-right' },
                { key: 'winner', label: 'Переможець', class: 'align-middle text-right' },
            ],
            show_binds: [],
        };
    },
    
    
    methods: {
        cost(item) {
            const maxSum = Number(item.max_price || 0) * Number(item.quantity || 0);
            const curSum = Number(item.full_cost || 0);
            if (curSum <= 0 || maxSum <= 0) return '0 (0%)';
            
            const diff = +(maxSum - curSum).toFixed(2);
            const proc = +((diff / maxSum) * 100).toFixed(0);
            return `${diff} (${proc}%)`;
        },
        
        winner(item) {
            if (!item?.last) return '';
            return item.last.user_id;
        },
        
        getUser(user_id) {
            return Array.isArray(this.users)
                ? this.users.find(u => String(u.user_id) === String(user_id))
                : null;
        },
        
        is_showDetail(row_id) {
            return this.show_binds.includes(row_id);
        },
        
        loadPreview(id, toggleDetails) {
            toggleDetails();
            if (this.is_showDetail(id)) {
                const idx = this.show_binds.indexOf(id);
                if (idx !== -1) this.show_binds.splice(idx, 1);
            } else {
                this.show_binds.push(id);
            }
        },
    },
    
    computed: {
        ...mapGetters({
            'users': "reduction/getUsers",
            'reduction' : 'reduction/getReduction'
        }),
    },
}
</script>


<style scoped>

</style>